import generate from 'nanoid/generate';
import Swal from 'sweetalert2'

export const setError = (detail) => {
    return { error: true, detail }
};

export const sum = (arr) => {
    let r = 0;
    arr.forEach((e) => {
        r += e;
    })
    return r;
};

export const getSessionId = () => {
    return generate('ABCDEFGHIJKLMNOP', 4) + generate('1234567890', 8);
}

export const checkIsEligible = (document) => {
    const {
        resultat_exercice,
        report_nouveau,
        reserve_autre,
        reserve_reglemente,
        reserve_statutaire,
        reserve_legal,
        prime_emission,
        capital_social,
    } = document;

    const res = (sum([capital_social, prime_emission]) / 2) + sum(
        [resultat_exercice,
            report_nouveau,
            reserve_autre,
            reserve_reglemente,
            reserve_statutaire,
            reserve_legal]
    )

    return res > 0;
}

export const createReport = (document, fields) => {
    let report = [];
    for(var key in document) {
        const field = fields.find((e) => { return e.name === key });
        if(!field) { continue } ;
        report.push(`${field.label}: ${document[key]}`);
    }
    return report;
} 


export const messages = {
    showValidated() {
      return Swal.fire({
        title: 'Formulaire',
        text: 'Informations envoyées. Vous allez recevoir un email de confirmation (verifiez vos spams).',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    },
    showLoading() {
      return Swal.fire({
        title: 'Soumission du formulaire',
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      });
    },
    showError() {
      return Swal.fire({
        title: 'Erreur',
        text: 'Erreur serveur',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    },
    showSumError() {
      return Swal.fire({
        title: 'Erreur',
        text: 'Somme de vérification inexacte.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    },
    close() {
      return Swal.close();
    }
  }